export default {"src":"/_next/static/media/new_message.4d73f355.gif","height":800,"width":800,"blurWidth":0,"blurHeight":0};